import { handleDecrypt, handleEncrypt } from "../common/utils/react-ec-utils";

export function getCookie(name: string): any {

  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  if (!match) return null;

  const encodedValue = match[1] as string;
  const encryptedValue = encodedValue;
  const decryptedValue = handleDecrypt(encryptedValue);

  try {
    return JSON.parse(decryptedValue);
  } catch {
    return decryptedValue;
  }
}


export function setCookie(name: string, value: any, days: number = 7) {
  const jsonString = typeof value === 'string' ? value : JSON.stringify(value);
  const encryptedValue = handleEncrypt(jsonString);
  const encodedValue = encryptedValue;

  let cookieString = `${name}=${encodedValue}; path=/`;
  if (days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    cookieString += `; expires=${expires}`;
  }

  document.cookie = cookieString;
}

export function deleteCookie(name: string) {
  const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const baseDomain = parts.length > 2 ? parts.slice(-2).join('.') : hostname;

  const domains = new Set<string>();
  domains.add('');
  domains.add(hostname);
  domains.add(`.${hostname}`);
  if (baseDomain && baseDomain !== hostname) {
    domains.add(baseDomain);
    domains.add(`.${baseDomain}`);
  }

  domains.forEach(domain => {
    const domainAttr = domain ? `; domain=${domain}` : '';
    document.cookie = `${name}=; Max-Age=0; expires=${expires}; path=/${domainAttr}`;
  });
}
